import { CLOSE_WEBPUSH_SUBSCRIBE_MODAL } from '../../constants/guideKeys';
import { makeHasReadGuideByKey } from '../../redux/selectors/tutorialGuideSelector';
import { useSelector } from '../../redux/utils';

export const useMakeHasReadGuideByKey = (
  guideKey: typeof CLOSE_WEBPUSH_SUBSCRIBE_MODAL
) => {
  const hasRead = useSelector(makeHasReadGuideByKey(guideKey, 1));

  return hasRead;
};
